import { render, staticRenderFns } from "./SetupHeader.vue?vue&type=template&id=2b2cf888&scoped=true"
import script from "./SetupHeader.vue?vue&type=script&lang=js"
export * from "./SetupHeader.vue?vue&type=script&lang=js"
import style0 from "./SetupHeader.vue?vue&type=style&index=0&id=2b2cf888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2cf888",
  null
  
)

export default component.exports